import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60 z-10"></div>

      <div className="relative z-20 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
              {heroData.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs font-medium rounded-full bg-accent-500/20 text-accent-300 border border-accent-500/30 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-background-50 leading-tight mb-4">
              {heroData.heading}
            </h1>

            <p className="text-sm md:text-base text-accent-300 font-heading mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-background-300/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat} className="text-center">
                  <p className="text-lg md:text-xl font-bold text-accent-400">
                    {stat.split(' ')[0]}
                  </p>
                  <p className="text-xs text-background-400 mt-1">
                    {stat.split(' ').slice(1).join(' ')}
                  </p>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.label}
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300/40 text-background-100 hover:bg-background-50/10 font-medium rounded-md text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.secondaryCta.label}
                <i className="ri-fire-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20digital%20illustration%20of%20trending%20entertainment%20news%20and%20gossip%20aggregation%2C%20warm%20coral%20and%20dark%20tones%2C%20social%20media%20feed%20aesthetic%2C%20floating%20headlines%20and%20speech%20bubbles%2C%20dynamic%20editorial%20composition%2C%20modern%20clean%20layout%2C%20artistic%20abstract%20representation%20of%20viral%20content%2C%20breaking%20news%20concept%2C%20warm%20lighting%20with%20amber%20accents%2C%20entertainment%20industry%20theme%2C%20high%20contrast%20dark%20background%20with%20vibrant%20warm%20highlights&width=1040&height=780&seq=hero-718-main&orientation=landscape"
                alt="黑料718 - 热门吃瓜合集与娱乐八卦"
                title="黑料718 - 热门吃瓜合集与娱乐八卦"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}